module.exports = __webpack_public_path__ + "static/img/duom011.251a008.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/duom011.png
// module id = 988
// module chunks = 0